//
// Note if changes are made to this file then they must be copied to amplify/background/function/portalSearch/src
//
module.exports = {
  description: {
    label: 'Company Description',
    type: 'textarea',
    name: 'description'
  },
  companyIndustry: {
    label: 'Industry Keywords',
    type: 'text',
    name: 'industryKeywords'
  },
  city: {
    label: 'Cities',
    type: 'text',
    name: 'city'
  },
  stateOrCountry: {
    label: 'States (abbr.) or Countries',
    type: 'text',
    name: 'stateOrCountry'
  },
  yearIncorporated: {
    label: 'Year Incorporated',
    tip: 'Incorporated or established',
    type: 'number',
    year: true,
    name:'yearIncorporated',
  },

  employees: {
    label: 'Number of Employees',
    type: 'number',
    name: 'employees'
  },

  fundingAmountCurrency: {
    label:'Funding Amount $',
    type:'number',
    name:'fundingAmountCurrency',
  },

  yearIncorporatedRange: {
    radio: true,
    label: 'Incorporated',
    name: 'yearIncorporated',
    fieldLabel: ['<1990', '<2000', '<2010', 'Any'],
    selectValues: ['<1990', '<2000', '<2010', ''],
  },
  
  employeesRange: {
    radio: true,
    label: 'Employees',
    name: 'employees',
    fieldLabel: ['<10', '<100', '<1000', 'Any'],
    selectValues: ['<10', '<100', '<1000', ''],
  },
  
  fundingAmountCurrencyRange: {
    radio: true,
    label: 'Funding Amount',
    name: 'fundingAmountCurrency',
    fieldLabel: ['<$10,000', '<$100,000', '<$1,000,000', '<$10,000,000', 'Any'],
    selectValues: ['<10000', '<100000', '<1000000', '<10000000', ''],
  },
  
  round: {
    radio: true,
    label: 'Funding Round',
    fieldLabel: ['Preseed', 'Seed', 'A', 'B', 'C', 'D', 'D+'],
    selectValues: ['preseed', 'seed', 'a', 'b', 'c', 'd', 'd+'],
    name:'round'
  },

  regType: {
    radio: true,
    label: 'Regulation Type',
    tip: 'SEC Regulation Type',
    fieldLabel: ['A Tier 1', 'A Tier 2', 'C', 'D', 'No Reg'],
    selectValues: ['a1', 'a2', 'c', 'd', 'noReg'],
    tipValues: [
      'Form 1-A Offering registration exemption up to $20 Million',
      'Form 1-A Offering registration exemption up to $50 Million',
      'Form C Crowdfunding Offering',
      'Form D Private offering registration exemption',
      ''
    ],
    name:'regType'
  },

  securityTypes: {
    checkbox: true,
    label: 'Security Types',
    fieldLabel: ['Common', 'Preferred', 'Debt'],
    selectValues: ['common', 'preferred', 'debt'],
    name: 'securityTypes'
  },

  legalForm: {
    radio: true,
    label:'Legal Form',
    fieldLabel: [
      'Corporation',
      'Limited Partnership (LP)',
      'Limited Liability Company (LLC)',
      'General Partnership (GP)',
      'Business Trust',
      'Other'
    ],
    selectValues: [
      'corporation',
      'limitedPartnership',
      'limitedLiabilityCompany',
      'generalPartnership',
      'businessTrust',
      'other'
    ],
    name:'legalForm'
  },

  revenueProducing: {
    radio: true,
    label: 'Revenue Producing',
    fieldLabel: ['Pre-revenue', 'Less than 12 Months', 'Less than 36 Months', '36 Months or More'],
    selectValues: ['preRevenue', 'revLT12', 'revLT36', 'revGE36'],
    name:'revenueProducing'
  },

  profitable: {
    radio: true,
    label: 'Profitable',
    fieldLabel: ['Never', 'Currently', 'Last Three Years (any)'],
    selectValues: ['profitNever', 'profitCurrent', 'profitThreeYears'],
    name:'profit'
  },

  industryNaics: {
    checkbox: true,
    label: 'Industry',
    fieldLabel:[
      'Agriculture, Forestry, Fishing and Hunting',
      'Mining',
      'Utilities',
      'Construction',
      'Manufacturing',
      'Wholesale Trade',
      'Retail Trade',
      'Transportation and Warehousing',
      'Information',
      'Finance and Insurance',
      'Real Estate Rental and Leasing',
      'Professional, Scientific, and Technical Services',
      'Management of Companies and Enterprises',
      'Administrative and Support and Waste Management and Remediation Services',
      'Educational Services',
      'Health Care and Social Assistance',
      'Arts, Entertainment, and Recreation',
      'Accommodation and Food Services',
      'Public Administration',
      'Other Services'
    ],
    selectValues:[
      'naics11',
      'naics21',
      'naics22',
      'naics23',
      'naics31_33',
      'naics42',
      'naics44_45',
      'naics48_49',
      'naics51',
      'naics52',
      'naics53',
      'naics54',
      'naics55',
      'naics56',
      'naics61',
      'naics62',
      'naics71',
      'naics72',
      'naics92',
      'naics81'
    ],
    name: 'industryNaics'
  }
}